import { render } from "./App.vue?vue&type=template&id=a660cf18&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a660cf18&lang=css"
import "./App.vue?vue&type=style&index=1&id=a660cf18&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a660cf18"]])

export default __exports__